export default function HostedVideoSection({ url }) {
  if (!url) {
    return null;
  }

  return (
    <section className="px-4 py-14 md:py-20" data-testid="hosted-video-section">
      <div className="container mx-auto max-w-4xl">
        <div className="mb-8 text-center">
          <p className="mb-2 text-xs font-medium uppercase tracking-widest text-orange-400">
            Відео з майстерні
          </p>
        </div>
        <video
          controls
          playsInline
          preload="metadata"
          className="mx-auto aspect-[9/16] w-full max-w-md rounded-xl bg-black"
          data-testid="hosted-video-player"
        >
          <source src={url} type="video/mp4" />
          Ваш браузер не підтримує відтворення відео.
        </video>
      </div>
    </section>
  );
}